export enum  VerificationStatus {
    VERIFIED = "verified",  
    RETRY = "retry", 
    DOCUMENT = "document", 
    SUSPENDED = "suspended", 
}



